<div class="visible-lg">
  <div class="flex-container row">
    <div class="bmw-bulletin-container flex-60">
      
      <div class="bmw-bulletin-title">
        {{getPageTitle()}}
      </div>

      <div *ngIf='actionType === "add"' class="cms-modal-select-make-checkbox">
        <label class="container" *ngFor='let make of makeList'>{{make?.makeName}}
          <input type="radio" name="radio" [value]="make" (change)="handleBrandChange()" [(ngModel)]='inputMake'>
          <span class="checkmark"></span>
        </label>
      </div>

      <div *ngIf='actionType === "edit"' class="cms-modal-select-make-checkbox">
        <label class="container" *ngFor='let make of makeList'>{{make?.makeName}}
          <input type="radio" name="radio" [value]="make" (change)="handleBrandChange()" [(ngModel)]='inputMake'>
          <span class="checkmark"></span>
        </label>
      </div>

      <div *ngIf='bulletinType === "video" && actionType === "add"'>
        <div class="flex-container">
          <div class="flex-30">
            <label>Video Number</label>
            <input [(ngModel)]='documentNumber' type="text" maxlength="8" placeholder="00 00 00" (keyup)="formatBulletinNumber($event, 'video')">
          </div>
          <div class="flex-70">
            <label>Channel Number</label>
            <div class="bmw-cms-new-bulletin-select">
              <select class="form-control" id="group" [(ngModel)]='inputChannel'>
                <option [ngValue]="undefined" disabled selected> Select Channel Number </option>
                <option *ngFor="let channel of channelsList" [ngValue]="channel">[{{channel?.channelNumber}}] {{channel?.channelName}}</option>
              </select>
            </div>
          </div>
        </div>
        <div class="flex-container">
          <div class="flex-30">
            <label>Date</label>
            <div >
              <input type="date" name="mydate" id="mydate" [(ngModel)]="inputDate" class="form-control" required />
            </div>
          </div>
          <div class="flex-30">
            <label>Related SIB</label>
            <input [(ngModel)]='bulletinNumber' type="text" maxlength="8" (keyup)="formatBulletinNumber($event, 'sib')"
              placeholder="00 00 00">
          </div>
          <i class="material-icons dp48 pointer" style="font-size: 30px;margin-left: -25px;line-height:3" (click)='addToSelection("sib", bulletinNumber)'>add_box</i>
        </div>
        <div class="flex-container" style="margin-top: 10px; margin-bottom:7px" *ngIf='relatedSIBs?.length > 0'>

        </div>
        <div class="flex-container">
          <div class="bmw-model-chips" style="margin-bottom:2%;margin-left: 30%">
            <div class="bmw-bulletin-series-chips" *ngFor='let bulletin of relatedSIBs'>
              {{bulletin}}
              <i class="material-icons" (click)='removeFromSelection("sib", bulletin)'>close</i>
            </div>
          </div>
        </div>
        <div class="flex-container">
          <div class="flex-70">
            <label>Video Title</label><br />
            <div>
              <input type="text" name="videoTitle" [(ngModel)]="textareaContent">
            </div>
          </div>
        </div>
        <div class="flex-container" style="margin-top: 20px">
          <div class="flex-70" >
            <label>Series:</label><br />
            <input class='bmw-series-dropdown' list="series" id="seriesList" [(ngModel)]='inputSeries' (change)='addToSelection("series", inputSeries)'
              name="seriesList" />
            <datalist id="series">
              <option *ngFor="let series of seriesList" [ngValue]="series">{{ series?.seriesName }}</option>
            </datalist>
          </div>
        </div>
        <!-- <div flex fxLayout="row" style="margin-top: 10px; margin-bottom:7px" *ngIf='seriesList?.length > 0'>

        </div> -->
        <div class="flex-container">
          <div>
            <div class="bmw-bulletin-series-chips" *ngFor='let series of seriesFilterList'>
              {{ series }}
              <i class="material-icons" (click)='removeFromSelection("series", series)'>close</i>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf='bulletinType === "obd" && actionType === "add"'>
        <div class="flex-container" style="margin-top: 20px">
          <div class="flex-40">
            <label>Document Number</label><br />
            <input disabled [(ngModel)]='documentNumber'>
          </div>
          <div class="flex-40">
            <label>Category</label><br />
            <div class="bmw-cms-new-bulletin-select">

              <select class="form-control" style="width: 280px;" id="group" [(ngModel)]='inputCategory'>
                <option [ngValue]="undefined" disabled selected> Select Category</option>
                <option value="OBD II Systems Information">OBD II Systems Information</option>
                <option value="OBD II Overview and Drive Cycle">OBD II Overview and Drive Cycle</option>
                <option value="Mode $06 Interface Data">Mode $06 Interface Data</option>
              </select>

            </div>
          </div>
          <div class="flex-15">
            <label>Year</label><br />
            <input [(ngModel)]='inputYear'>
          </div>
        </div>
        <div class="flex-container" style="margin-top: 20px">
          <div class="flex-40">
            <label>Engine/DME</label>
            <div>
              <input [(ngModel)]='engineName' placeholder="Enter Engine">
            </div>
          </div>
          <div class="flex-30">
            <label>Date</label>
            <div >
              <!-- TODO: may be removed -->
              <!-- <my-date-picker name="mydate" [options]="myDatePickerOptions" [(ngModel)]="inputDate" [placeholder]="'YYYY-MM-DD'"
                required></my-date-picker> -->
                <input type="date" name="mydate" [placeholder]="'YYYY-MM-DD'" [(ngModel)]="inputDate"  class="form-control" required />
            </div>
          </div>
        </div>
        <div class="flex-container" style="margin-bottom: 20px">
          <label>Engines:</label>
          <input style="margin-left: 10px" class='bmw-series-dropdown' list="engine" id="enginesList" [(ngModel)]='inputEngine'
            (change)='addToSelection("engine", inputEngine)' name="seriesList" />
          <datalist id="engine">
            <option *ngFor="let engine of enginesList" [ngValue]="engine">{{engine?.engineName}}</option>
          </datalist>
        </div>
        <div class="flex-container" style="margin-top: 10px; margin-bottom:7px" *ngIf='enginesFilterList?.length > 0'>
        </div>
        <div class="flex-container">
          <div class="bmw-model-chips" style="margin-bottom: 15px">
            <div class="bmw-bulletin-series-chips" *ngFor='let engine of enginesFilterList'>
              {{ engine }}
              <i class="material-icons" (click)='removeFromSelection("engine", engine)'>close</i>
            </div>
          </div>
        </div>
        <div class="flex-container" style="margin-bottom: 20px">
          <label>Series:</label>
          <input style="margin-left: 10px" class='bmw-series-dropdown' list="series" id="seriesList" [(ngModel)]='inputSeries'
            (change)='addToSelection("series", inputSeries)' name="seriesList" />
          <datalist id="series">
            <option *ngFor="let series of seriesList" [ngValue]="series">{{series?.seriesName}}</option>
          </datalist>
        </div>
        <div class="flex-container" style="margin-top: 10px; margin-bottom:7px" *ngIf='seriesFilterList?.length > 0'>
        </div>
        <div class="flex-container">
          <div class="bmw-model-chips" style="margin-bottom: 15px">
            <div class="bmw-bulletin-series-chips" *ngFor='let series of seriesFilterList'>
              {{ series }}
              <i class="material-icons" (click)='removeFromSelection("series", series)'>close</i>
            </div>
          </div>
        </div>

      </div>
      <div *ngIf='bulletinType === "tool" && actionType === "add"'>
        <div class="flex-container">
          <div class="flex-40">
            <label>6-digit Part Number</label>
            <div>
              <input type="text" [(ngModel)]='partNumber' placeholder="Enter Number" maxlength="8" (keyup)="formatBulletinNumber($event, 'part')">
            </div>
          </div>
        </div>
        <div>
          <div class="flex-container" style="margin-top: 20px">
            <div class="flex-40">
              <label>Order Part Number (11 digits)</label>
              <input type="text" [(ngModel)]='documentNumber' placeholder="Enter Number" maxlength="15" (keyup)="formatBulletinNumber($event, 'order')">
            </div>
            <div class="flex-30">
              <label>Date</label>
              <div>
                <!-- TODO: may be removed -->
                <!-- <my-date-picker name="mydate" [options]="myDatePickerOptions" [(ngModel)]="inputDate" required></my-date-picker> -->
                 <input type="date" name="mydate" [(ngModel)]="inputDate" class="form-control" required />
              </div>
            </div>
            <div class="flex-30">
              <label>Related SIB</label>
              <input [(ngModel)]='bulletinNumber' maxlength="8" (keyup)="formatBulletinNumber($event, 'sib')">
            </div>
          </div>
        </div>
        <div class="cms-modal-select-make-checkbox">
          <label class="container sm">Autoships
            <input type="checkbox" name="autoship" value="autoship" [(ngModel)]='autoship'>
            <span class="checkmark"></span>
          </label>
          <label class="container sm" style="margin-right:0em;width:20em">Has External MFR Warranty
            <input type="checkbox" name="warranty" value="warranty" [(ngModel)]='warranty'>
            <span class="checkmark"></span>
          </label>
        </div>
        <div class="flex-container" style="margin-top: 20px">
          <div class="flex-60">
            <label>Tool Description</label>
            <div>
              <input type="text" name="toolDesc" [(ngModel)]="toolDesc">
            </div>
          </div>
          <div class="flex-40">
            <label>Tool Location</label>
            <div>
              <input type="text" name="toolLoc" [(ngModel)]="toolLoc">
            </div>
          </div>
        </div>
        <!-- <div flex flexLayout="row" style="margin-top: 20px">
          <label>Category</label>
          <div>
            <input style="width: 40%" type="text" name="category" [(ngModel)]="inputCategory">
          </div>
        </div> -->
        <div flex flexLayout="row" style="margin-top: 20px">
          <label>Notes</label>
          <div>
            <textarea [(ngModel)]='textareaContent' placeholder="Enter Notes"></textarea>
          </div>
        </div>


        <!-- Model Not Needed Add Series
        <div flex flexLayout="row" style="margin-top: 20px">
          <label>Models:</label>
          <input class='bmw-models-dropdown' list="models" id="modelsList" [(ngModel)]='inputModel' (change)='addToSelection("model", inputModel)'
            name="modelsList" />
          <datalist id="models">
            <option *ngFor="let model of modelsList" [ngValue]="model">{{model?.modelName}}</option>
          </datalist>
        </div>

        
        <div flex fxLayout="row" style="margin-top: 10px; margin-bottom:7px" *ngIf='modelsList?.length > 0'>
        </div>
        <div flex fxLayout="row">
          <div class="bmw-model-chips" style="margin-bottom: 15px">
            <div class="bmw-bulletin-series-chips" *ngFor='let model of modelsFilterList'>
              {{model}}
              <i class="material-icons" (click)='removeFromSelection("model", model)'>close</i>
            </div>
          </div>
        </div> -->

        <div class="flex-container" style="margin-bottom: 20px">
          <label>Series:</label>
          <input style="margin-left: 10px" class='bmw-series-dropdown' list="series" id="seriesList" [(ngModel)]='inputSeries'
            (change)='addToSelection("series", inputSeries)' name="seriesList" />
          <datalist id="series">
            <option *ngFor="let series of seriesList" [ngValue]="series">{{series?.seriesName}}</option>
          </datalist>
        </div>
        <div class="flex-container" style="margin-top: 10px; margin-bottom:7px" *ngIf='seriesFilterList?.length > 0'>
        </div>
        <div class="flex-container">
          <div class="bmw-model-chips" style="margin-bottom: 15px">
            <div class="bmw-bulletin-series-chips" *ngFor='let series of seriesFilterList'>
              {{ series }}
              <i class="material-icons" (click)='removeFromSelection("series", series)'>close</i>
            </div>
          </div>
        </div>

      </div>
      <div *ngIf='bulletinType === "video" && actionType === "edit"'>
        <div class="flex-container">
          <div class="flex-15">
            <select class="form-control" id="group" (change)='getAllVideoNumbers(makeNameForApi)' [(ngModel)]='makeNameForApi'
              style="width:80%;margin-top: 25px; margin-left:5px">
              <option *ngIf="!isMotorradAdmin && !isRollsRoyceAdmin" value="BMW">BMW</option>
              <option *ngIf="!isMotorradAdmin && !isRollsRoyceAdmin" value="MINI">MINI</option>      
              <option *ngIf="isAdmin || isMotorradAdmin" value="MOTORRAD">MOTORRAD</option> 
              <option *ngIf="isAdmin || isRollsRoyceAdmin" value="ROLLSROYCE">ROLLSROYCE</option>               
            </select>
          </div>
          <div class="flex-30">
            <label>Video Number</label>
            <input list="videoNumbers" id="seriesList" [disabled]='!makeNameForApi' [(ngModel)]='documentNumber' name="seriesList" />
            <datalist id="videoNumbers">
              <option *ngFor="let videoNumber of documentNumbersList" [ngValue]="videoNumber">{{videoNumber}}</option>
            </datalist>
          </div>
          <div class="flex">
            <i class="material-icons dp48 pointer submit" style="margin-top: 27px" (click)='getVideoData(documentNumber, makeNameForApi)'>keyboard_arrow_right</i>
          </div>
        </div>
        <div *ngIf='showAllFields == true'>
          <small style="font-weight: bold;margin-left: 10px" [ngStyle]='{"color": isDocActive ? "#59a946" : "#8b928a"}'>
            {{isDocActive ? "Active" : "In-active"}}
          </small>
          <div class="flex-container">
            <div class="flex-70">
              <label>Channel Number</label><br />

              <div class="bmw-cms-new-bulletin-select">
                <!-- <select class="form-control" id="group" [(ngModel)]='inputChannel'>
                  <option [ngValue]="undefined" disabled selected> Select Channel Number </option>
                  <option *ngFor="let channel of channelsList" [ngValue]="channel">{{channel?.channelName}}</option>
                </select> -->
                <input list="channels" id="seriesList" [(ngModel)]='inputChannel' name="seriesList" />
                <datalist id="channels">
                  <option *ngFor="let channel of channelsList" [ngValue]="channel">[{{channel?.channelNumber}}] {{channel?.channelName}}</option>
                </datalist>

              </div>
            </div>
          </div>
          <div class="flex-container" style="margin-top: 20px;">
            <div class="flex-30">
              <label>Date</label>
              <div>
                <!-- TODO: may be removed -->
                <!-- <my-date-picker name="mydate" [selDate]='selDate' [options]="myDatePickerOptions" [(ngModel)]="inputDate"
                  required></my-date-picker> -->
                  <input type="date" name="mydate" [(ngModel)]="inputDate" class="form-control" required />
              </div>
            </div>
            <div class="flex-30">
              <label>Related SIB</label>
              <input [(ngModel)]='bulletinNumber' type="text" maxlength="8" placeholder="00 00 00" (keyup)="formatBulletinNumber($event, 'sib')">
            </div>
            <i class="material-icons dp48 pointer" style="font-size: 30px;margin-left: -25px;line-height:3" (click)='addToSelection("sib", bulletinNumber)'>add_box</i>
          </div>
          <!-- <div flex fxLayout="row" style="margin-top: 10px; margin-bottom:7px" *ngIf='relatedSIBs?.length > 0'>

          </div> -->
          <div class="flex-container">
            <div class="bmw-model-chips" style="margin-bottom:2%;margin-left: 30%">
              <div class="bmw-bulletin-series-chips" *ngFor='let bulletin of relatedSIBs'>
                {{bulletin}}
                <i class="material-icons" (click)='removeFromSelection("sib", bulletin)'>close</i>
              </div>
            </div>
          </div>
          <div class="flex-container">
            <div class="flex-12">
              <label>Video Title:</label>
            </div>
            <div class="flex-60">
              <input type="text" name="videoTitle" [(ngModel)]="textareaContent">
            </div>
          </div>
          <div class="flex-container" style="margin-top: 20px">
            <div class="flex-12">
              <label>Series:</label>
            </div>
            <div class="flex-25">
              <input class='bmw-series-dropdown' list="series" id="seriesList" [(ngModel)]='inputSeries' (change)='addToSelection("series", inputSeries)'
                name="seriesList" />
              <datalist id="series">
                <option *ngFor="let series of seriesList" [ngValue]="series">{{series?.seriesName}}</option>
              </datalist>
            </div>
          </div>
          <div class="flex-container" style="margin-top: 10px; margin-bottom:7px" *ngIf='seriesList?.length > 0'>

          </div>
          <div class="flex-container">
            <div class="bmw-model-chips">
              <div class="bmw-bulletin-series-chips" *ngFor='let series of seriesFilterList'>
                {{series}}
                <i class="material-icons" (click)='removeFromSelection("series", series)'>close</i>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf='bulletinType === "tool" && actionType === "edit"'>
        <div class="flex-container">
          <div class="flex-15">
            <select class="form-control" id="group" [(ngModel)]='makeNameForApi' (change)='getAllToolReportNumbers(makeNameForApi)'
              style="width:80%;margin-top: 25px; margin-left:5px">
              <option value="undefined" disabled selected></option>
              <option *ngIf="!isMotorradAdmin && !isRollsRoyceAdmin" value="BMW">BMW</option>
              <option *ngIf="!isMotorradAdmin && !isRollsRoyceAdmin" value="MINI">MINI</option>      
              <option *ngIf="isAdmin || isMotorradAdmin" value="MOTORRAD">MOTORRAD</option> 
              <option *ngIf="isAdmin || isRollsRoyceAdmin" value="ROLLSROYCE">ROLLSROYCE</option>               
            </select>
          </div>
          <div class="flex-40">
            <label>Order Part Number (11 digits)</label>
            <div class="bmw-cms-new-bulletin-select">
              <select class="form-control" id="group" [disabled]='!makeNameForApi' style="width: 80%" [(ngModel)]='documentNumber'>
                <option *ngFor="let orderPartNumber of documentNumbersList" [ngValue]="orderPartNumber">
                  {{orderPartNumber}}</option>
              </select>
            </div>
          </div>
          <div class="flex">
            <i class="material-icons dp48 pointer submit" style="margin-top: 27px" (click)='getToolReportData(documentNumber, makeNameForApi)'>keyboard_arrow_right</i>
          </div>
        </div>
        <div *ngIf='showAllOptionsTool == true'>
          <small style="font-weight: bold;margin-left: 10px" [ngStyle]='{"color": isDocActive ? "#59a946" : "#8b928a"}'>
            {{isDocActive ? "Active" : "In-active"}}
          </small>
          <div class="flex-container" style="margin-top: 20px">
            <div class="flex-40">
              <label>Part Number (6 digits)</label>
              <input type="text" [(ngModel)]='partNumber' placeholder="Enter Number" (keyup)="formatBulletinNumber($event, 'part')">
            </div>
            <div class="flex-30">
              <label>Date</label>
              <div>
                <!-- TODO: may be removed -->
                <!-- <my-date-picker name="mydate" [selDate]='selDate' [options]="myDatePickerOptions" [(ngModel)]="inputDate"
                  required></my-date-picker> -->
                  <input type="date" name="mydate" [(ngModel)]="inputDate" class="form-control" required />
              </div>
            </div>
            <div class="flex-30">
              <label>Related SIB</label>
              <input [(ngModel)]='bulletinNumber' (keyup)="formatBulletinNumber($event, 'sib')">
            </div>
          </div>

          <div class="cms-modal-select-make-checkbox">
            <label class="container sm">Autoships
              <input type="checkbox" name="autoship" value="autoship" [(ngModel)]='autoship'>
              <span class="checkmark"></span>
            </label>
            <label class="container sm" style="margin-right:0em;width:20em">Has External MFR Warranty
              <input type="checkbox" name="warranty" value="warranty" [(ngModel)]='warranty'>
              <span class="checkmark"></span>
            </label>
          </div>
          <div class="flex-container" style="margin-top: 20px">
            <div class="flex-60">
              <label>Tool Description</label>
              <div>
                <input type="text" name="toolDesc" [(ngModel)]="toolDesc">
              </div>
            </div>
            <div class="flex-40">
              <label>Tool Location</label>
              <div>
                <input type="text" name="toolLoc" [(ngModel)]="toolLoc">
              </div>
            </div>
          </div>

          <!-- <div flex flexLayout="row" style="margin-top: 20px">
            <label>Category</label>
            <div>
              <input style="width: 40%" type="text" name="category" [(ngModel)]="inputCategory">
            </div>
          </div> -->

          <div flex flexLayout="row" style="margin-top: 20px">
            <label>Notes</label>
            <div>
              <textarea [(ngModel)]='textareaContent' placeholder="Enter Notes"></textarea>
            </div>
          </div>

          <!-- Model not needed add series 
          <div flex flexLayout="row" style="margin-top: 20px">
            <label>Models:</label>
            <input class='bmw-models-dropdown' list="models" id="modelsList" [(ngModel)]='inputModel' (change)='addToSelection("model", inputModel)'
              name="modelsList" />
            <datalist id="models">
              <option *ngFor="let model of modelsList" [ngValue]="model">{{model?.modelName}}</option>
            </datalist>
          </div>

          <div class="flex-container" style="margin-top: 10px; margin-bottom:7px" *ngIf='modelsList?.length > 0'>
          </div>
          <div class="flex-container">
            <div class="bmw-model-chips" style="margin-bottom: 15px">
              <div class="bmw-bulletin-series-chips" *ngFor='let model of modelsFilterList'>
                {{model}}
                <i class="material-icons" (click)='removeFromSelection("model", model)'>close</i>
              </div>
            </div>
          </div>
        -->
          <div class="flex-container" style="margin-top: 20px">
            <div class="flex-12">
              <label>Series:</label>
            </div>
            <div class="flex-25">
              <input class='bmw-series-dropdown' list="series" id="seriesList" [(ngModel)]='inputSeries' (change)='addToSelection("series", inputSeries)'
                name="seriesList" />
              <datalist id="series">
                <option *ngFor="let series of seriesList" [ngValue]="series">{{series?.seriesName}}</option>
              </datalist>
            </div>
          </div>
          <div class="flex-container" style="margin-top: 10px; margin-bottom:7px" *ngIf='seriesList?.length > 0'>

          </div>
          <div class="flex-container">
            <div class="bmw-model-chips">
              <div class="bmw-bulletin-series-chips" *ngFor='let series of seriesFilterList'>
                {{series}}
                <i class="material-icons" (click)='removeFromSelection("series", series)'>close</i>
              </div>
            </div>
          </div>


        </div>
      </div>
      <div *ngIf='bulletinType === "obd" && actionType === "edit"'>
        <div class="flex-container" style="margin-top: 20px">
          <div class="flex-15">
            <select class="form-control" id="group" [(ngModel)]='makeNameForApi' (change)='getOBDCOntent(makeNameForApi)'
              style="width:80%;margin-top: 25px; margin-left:5px">
              <option value="undefined" disabled selected></option>
              <option *ngIf="!isMotorradAdmin && !isRollsRoyceAdmin" value="BMW">BMW</option>
              <option *ngIf="!isMotorradAdmin && !isRollsRoyceAdmin" value="MINI">MINI</option>      
              <option *ngIf="isAdmin || isMotorradAdmin" value="MOTORRAD">MOTORRAD</option> 
              <option *ngIf="isAdmin || isRollsRoyceAdmin" value="ROLLSROYCE">ROLLSROYCE</option>              
            </select>
          </div>

          <div class="flex-25">
            <label>Document Name</label>
            <input style="margin-left: 10px" list="docNumbers" [disabled]='!makeNameForApi' id="docNumbers1"
              [(ngModel)]='documentOBDTitle' name="docNumbers1" />

            <datalist id="docNumbers">
              <option *ngFor="let doc of obdCategories" [ngValue]="doc?.documentNumber">{{ doc?.documentFileName }}</option>
            </datalist>
          </div>
          <div class="flex-30" *ngIf='showAllOptionsOBD == true'>
            <label>Category</label>
            <input style="margin-left: 10px" disabled [(ngModel)]='inputCategory' />
          </div>
          <div class="flex">
            <i class="material-icons dp48 pointer submit" style="margin-top: 27px" (click)='getOBDData(documentOBDTitle, makeNameForApi)'>keyboard_arrow_right</i>
          </div>
        </div>
      </div>
      <div *ngIf='showAllOptionsOBD == true'>
        <small style="font-weight: bold;margin-left: 10px" [ngStyle]='{"color": isDocActive ? "#59a946" : "#8b928a"}'>
          {{isDocActive ? "Active" : "In-active"}}
        </small>
        <div class="flex-container" style="margin-top: 20px">
          <div class="flex-40">
            <label>Engine/DME</label>
            <input [(ngModel)]='engineName' placeholder="Enter Engine">
          </div>
          <div class="flex-30">
            <label>Date</label>
            <div>
              <!-- TODO: may be removed -->
              <!-- <my-date-picker name="mydate" [selDate]='selDate' [options]="myDatePickerOptions" [(ngModel)]="inputDate"
                required></my-date-picker> -->
                <input type="date" name="mydate" [(ngModel)]="inputDate" class="form-control" required />
            </div>
          </div>
          <div class="flex-20">
            <label>Year</label>
            <input type="text" [(ngModel)]='inputYear'>
          </div>
        </div>
        <div class="flex-container" style="margin-bottom: 20px">
          <label>Engines:</label>
          <!-- <input style="margin-left: 10px" class='bmw-series-dropdown' list="engine" id="enginesList" [(ngModel)]='inputEngine' (change)='addToSelection("engine", inputEngine)'
              name="enginesList" />
            <datalist id="engine">
              <option *ngFor="let engine of enginesList" [ngValue]="engine">{{engine?.engineName}}</option>
            </datalist> -->
          <select style="width: 45%" class="form-control" id="group" (change)='addToSelection("engine", inputEngine)'
            [(ngModel)]='inputEngine'>
            <option *ngFor="let engine of enginesList" [ngValue]="engine">{{engine?.engineName}}</option>
          </select>
        </div>
        <div class="flex-container" style="margin-top: 10px; margin-bottom:7px" *ngIf='enginesFilterList?.length > 0'>
        </div>
        <div class="flex-container">
          <div class="bmw-model-chips" style="margin-bottom: 15px">
            <div class="bmw-bulletin-series-chips" *ngFor='let engine of enginesFilterList'>
              {{engine}}
              <i class="material-icons" (click)='removeFromSelection("engine", engine)'>close</i>
            </div>
          </div>
        </div>
        <div class="flex-container" style="margin-bottom: 20px">
          <label>Series:</label>
          <input style="margin-left: 10px" class='bmw-series-dropdown' list="series" id="seriesList" [(ngModel)]='inputSeries'
            (change)='addToSelection("series", inputSeries)' name="seriesList" />
          <datalist id="series">
            <option *ngFor="let series of seriesList" [ngValue]="series">{{series?.seriesName}}</option>
          </datalist>
        </div>
        <div class="flex-container" style="margin-top: 10px; margin-bottom:7px" *ngIf='seriesFilterList?.length > 0'>
        </div>
        <div class="flex-container">
          <div class="bmw-model-chips" style="margin-bottom: 15px">
            <div class="bmw-bulletin-series-chips" *ngFor='let series of seriesFilterList'>
              {{series}}
              <i class="material-icons" (click)='removeFromSelection("series", series)'>close</i>
            </div>
          </div>
        </div>

      </div>
      <!-- Reactivate or Deactivate document  -->
      <div class="flex-container" style="margin-top: 20px">
        <div class="cms-modal-select-make-checkbox">
          <label class="container sm">Reactivate
            <input type="radio" id="reactivateOTV" name="reactivateOTV" value="reactivate" [(ngModel)]='reactivateOrDeactivate'>
            <span class="checkmark"></span>
          </label>
          <label class="container sm" style="margin-right:0em;width:10em">Deactivate
            <input type="radio" id="deactivateOTV" name="deactivateOTV" value="deactivate" [(ngModel)]='reactivateOrDeactivate'>
            <span class="checkmark"></span>
          </label>
        </div>
      </div>

      <!-- Is Takata Recall -->
      <div class="flex-container" *ngIf="showTakata">
        <div class="flex-30">
          <label class="container is-takata-recall">Is Takata Recall?
            <input type="checkbox" name="chechbox" value='isTakataRecall' [(ngModel)]='isTakataRecall'>
            <span class="checkmark"></span>
          </label>
        </div>
        <div class="flex-30">
          <label>Takata Recall Code</label>
          <input type="text" name="tkr" [disabled]='!isTakataRecall' placeholder="ex 14V-428" [(ngModel)]="tkrCode"
            required>
        </div>
      </div>

      <!-- Upload File -->
      <div class="flex-container">
        <div *ngIf='bulletinType === "video"'>
          <div class="flex-30">
            <label>Vimeo ID:</label>
          </div>
          <div class="flex=100">
            <input type="text" autocomplete="off" name="vimeoID" [(ngModel)]="vimeoID">
          </div>
          <!--<small style="color: red">{{ errorMessage }}</small>-->
        </div>

        <div *ngIf='bulletinType === "obd" || bulletinType === "tool"' class="bmw-cms-modal-button new-bulletin">
          <div class="upload-btn-wrapper flex-150-px">
            <button class="btn pointer">Choose File</button>
            <input type="file" name="myfile" (change)='fileUpload($event)' />
          </div>
          <div class="bmw-bulletin-nofile-label flex">{{ uploadedFileName }}</div>
        </div>
        <small style="color: red">{{ errorMessage }}</small>

      </div>
      <!-- Submit -->
      <div class="flex-container">
        <div class="bmw-cms-modal-button new-bulletin">
          <button [disabled]='!inputMake' class="bmw-button-secondary" (click)='submit()'>Submit</button>
        </div>
      </div>

    </div>
  </div>
</div>